(function ($, App, Utils, Components, Pages) {
  'use strict';

  const logger = new Logger('StoreLocatorComponent');

  Components.create('StoreLocatorComponent', {

    Selectors: {
      main: '.js-store-locator-main',
      page: '.store-locator-page',
      header: $('.js-store-locator-header'),
	    storeLocatorComponentWrapper: $('.store-locator-component'),
      mapContainer: $('#store-locator'),
      map: $('#googlemap'),
      search: $('#googlesearch'),
      filterForm: $('.js-filter-form'),
      filterOpen: $('#open-today'),
      filterBrands: $('.filters-brands input'),
      filterServices: $('.filters-services input'),
      filterPromos: $('input.filters-promo'),
      filterTypes: $('input.filters-types'),
      setPosition: $('.js-my-position'),
      storeItemTemplate: $('#store-item-template'),
      storesLengthTemplate: $('#stores-array-length'),
      storesLengthContainer: $('.js-store-length-container'),
      storeListContainer: $('.js-store-list-container'),
      storeOverlay: $('.js-store-overlay'),
      zoomIn: $('#controls_zoom_in'),
      zoomOut: $('#controls_zoom_out'),
      siteHeader: $('.js-header'),
      aside: $('.store-locator-main-aside'),
      mapAction: $('.map-actions.hide-for-large'),
      storelocatorHeader: $('.store-locator-sidebar-header'),
      selectedPDV: $('.selected'),
      unselectedPDV: $('.unselected')
    },

    bindEvents: () => {


      Components.StoreLocatorComponent.storeLocator.on("change-address", (e, address, fixed_point) => {
        // logger.warn("change-address", fixed_point,fixed_point.bounds, Components.StoreLocatorComponent.storeLocator.Map.bounds);
        Components.StoreLocatorComponent.Selectors.search.val(address);
        logger.warn("store:", address);
        if (fixed_point) {
          Components.StoreLocatorComponent.storeLocator.navigateLocation(fixed_point.bounds).then(() => {
            Components.StoreLocatorComponent.getStores(Components.StoreLocatorComponent.storeLocator.Map.bounds, false);
          });
        } else {
          logger.warn('change-address: no location received');
        }
      });

      Components.StoreLocatorComponent.Selectors.filterForm.on('submit.st', (e) => {
        e.preventDefault();
        Components.StoreLocatorComponent.getStores(Components.StoreLocatorComponent.storeLocator.Map.bounds);
      });

      Components.StoreLocatorComponent.Selectors.setPosition.on('click.st', (e) => {
        Components.StoreLocatorComponent.getCurrentLocation();
      });

      Components.StoreLocatorComponent.Selectors.zoomIn.on('click.st', function () {
        Components.StoreLocatorComponent.storeLocator.zoom = 1;
        Components.StoreLocatorComponent.getStores(Components.StoreLocatorComponent.storeLocator.Map.bounds, true);
      });
      Components.StoreLocatorComponent.Selectors.zoomOut.on('click.st', function () {
        Components.StoreLocatorComponent.storeLocator.zoom = -1;
        Components.StoreLocatorComponent.getStores(Components.StoreLocatorComponent.storeLocator.Map.bounds, true);
      });

      Components.StoreLocatorComponent.storeLocator.on("mappan", (e) => {
        Components.StoreLocatorComponent.getStores(Components.StoreLocatorComponent.storeLocator.Map.bounds, true);
      });

      Components.StoreLocatorComponent.Selectors.selectedPDV.on('click', (e) => {
        $(Components.StoreLocatorComponent.Selectors.filterBrands).prop('checked', true);
      });

      Components.StoreLocatorComponent.Selectors.unselectedPDV.on('click', (e) => {
        $(Components.StoreLocatorComponent.Selectors.filterBrands).prop('checked', false);
      });

    },

    initStoreLocator: () => {

      Promise.all([Components.StoreLocatorComponent.promiseGmap, Components.StoreLocatorComponent.promiseGsearch]).then((engines) => {

        let GMap = engines[0], GSearch = engines[1];
        Components.StoreLocatorComponent.storeLocator.addMapEngine('GoogleMap', GMap);
        Components.StoreLocatorComponent.storeLocator.addSearchEngine('GoogleSearch', GSearch);
        Components.StoreLocatorComponent.getCurrentLocation();

      });
    },

    getCurrentLocation: () => {
      Components.StoreLocatorComponent.storeLocator.currentLocation().then((obj) => {
        logger.d("Current location is", obj);
        // You can now navigate to
         // Components.StoreLocatorComponent.storeLocator.navigate(null, obj);
         Components.StoreLocatorComponent.storeLocator.navigate(null, obj).then(() => {
           Components.StoreLocatorComponent.getStores(Components.StoreLocatorComponent.storeLocator.Map.bounds, false);
         });
      }, (err) => {
        logger.e('storeLocator.currentLocation() =>>', err);
        Components.trigger(Components.Loader.Events.hide);

        /* viene mostrato SEMPRE
        Components.trigger('modal:alert', [{
          unsafeContent: `<h3>Attenzione</h3><p>${Components.StoreLocatorComponent.data.noposition}</p>`
        }]);
        */

        Components.StoreLocatorComponent.Selectors.setPosition.attr('disabled', 'disabled').addClass('disabled');
        Components.StoreLocatorComponent.storeLocator.navigate(Components.StoreLocatorComponent.data.default, null);

      }, {
        timeout: 15000
      });
    },

    getStores: (bounds, dontchangelocation) => {

      // logger.warn("getstores", bounds, dontchangelocation);
      let brandsFilter = Components.StoreLocatorComponent.Selectors.filterBrands.serializeArray().filter(f => f.value).map(f => f.name);
      let reqData = brandsFilter ? {
        bounds: bounds,
        openToday: Components.StoreLocatorComponent.Selectors.filterOpen.prop("checked"),
        servicesFilter: Components.StoreLocatorComponent.Selectors.filterServices.serializeArray().filter(f => f.value).map(f => f.name),
        brandsFilter: brandsFilter,
        typesFilter: Components.StoreLocatorComponent.Selectors.filterTypes.serializeArray().filter(f => f.value).map(f => f.value),
        promoFilter: Components.StoreLocatorComponent.Selectors.filterPromos.val(),
        partnersFilter: Components.StoreLocatorComponent.data.partners ? Components.StoreLocatorComponent.data.partners.split(",") : [],
        uuid: Components.StoreLocatorComponent.data.uuid,
        registration: Boolean(Components.StoreLocatorComponent.data.registration)
      } : null;

      Components.trigger(Components.Loader.Events.show, [{
        parent: Components.StoreLocatorComponent.Selectors.main
      }]);


      let getStoresList = reqData => {
        return reqData ? axios({
          method: 'post',
          url: Components.StoreLocatorComponent.data.storesendpoint,
          responseType: 'text',
          data: reqData
        }) : {}
      };

      let getStoresMapData = reqData => {
        return reqData ? axios({
          method: 'post',
          url: Components.StoreLocatorComponent.data.mapendpoint,
          responseType: 'json',
          data: reqData
        }) : {}
      };

      getStoresList(reqData).then(storeList => {
        let htmlList = storeList && storeList.data ? storeList.data : false;

        if (htmlList) {
          Components.StoreLocatorComponent.Selectors.storeListContainer.html(htmlList);
        } else {
          logger.w("lista store vuota");
        }

      }).catch(err => logger.w(err));

      getStoresMapData(reqData).then(storeData => {

        let mapData = storeData && storeData.data ? storeData.data : false;


        if (mapData) {
          if (mapData.return.bounds && !dontchangelocation) {
            let refreshBounding = JSON.parse(mapData.return.bounds);
            delete refreshBounding.center;
            let cb = Components.StoreLocatorComponent.makePins(mapData);
            Components.StoreLocatorComponent.storeLocator.navigateLocation(refreshBounding).then(() => {
              cb && cb();
            });
          }else {
            Components.StoreLocatorComponent.makePins(mapData);
          }
        } else {
          logger.w("lista store mappa vuota");
        }

      }).catch(err => logger.w(err));

      Components.trigger(Components.Loader.Events.hide);

    },

    highlightStore: (code, showOverlay) => {
      logger.d("Store code =>> ", code);

      let containerScrollTop = Components.StoreLocatorComponent.Selectors.storeListContainer.scrollTop();
      let $selectedStore = $(`[data-store-code='${code}']`).not('.header-store');
      let offset = $selectedStore.position().top;
      // let outerHeight = $selectedStore.outerHeight();

      let scrollValue = (containerScrollTop + offset);

      $selectedStore.siblings().removeClass('selected');
      $selectedStore.addClass('selected');

      if (App.Html.hasClass('ie')) {
        Components.StoreLocatorComponent.Selectors.storeListContainer.animate({scrollTop: scrollValue}, 400);
      } else {
        Components.StoreLocatorComponent.Selectors.storeListContainer.scrollTop(scrollValue);
      }

      if (showOverlay && Components.StoreLocatorComponent.Selectors.storeOverlay.find(`[data-store-code='${code}']`).length === 0) {
        Components.StoreLocatorComponent.Selectors.storeOverlay.find('.store-item').remove();
        Components.StoreLocatorComponent.Selectors.storeOverlay.addClass('visible');
        $selectedStore.clone().appendTo(Components.StoreLocatorComponent.Selectors.storeOverlay);
      }

    },

    makePins: (data) => {
      Components.StoreLocatorComponent.storeLocator.showPoint(data, true).then(function (gPoints) {

        let storesLengthHtml = Components.StoreLocatorComponent.storesLengthTemplate(data.featuresSize);
        Components.StoreLocatorComponent.Selectors.storesLengthContainer.html(storesLengthHtml);

        $.each(gPoints, function (i, point) {
          let pointData = point.data; // Get the Store data from pin

          point.image = {
            Url: `${Components.StoreLocatorComponent.data.docroot}/images/${Components.StoreLocatorComponent.data.brand}/store-locator/pins/${pointData.storeType}.png`,
            Size: {
              w: 50,
              h: 73
            }
          };

          point.on('click', function () {
            Components.StoreLocatorComponent.highlightStore(pointData.storeCode, Utils.Responsive.isSM() || Utils.Responsive.isXS());
          });
        });

      });
    },


    initTemplate: () => {
      const storesLengthTemplate = Components.StoreLocatorComponent.Selectors.storesLengthTemplate.html();
      Components.StoreLocatorComponent.storesLengthTemplate = Handlebars.compile(storesLengthTemplate);
    },

    setMainHeight: () => {
      let headerHeight = Components.StoreLocatorComponent.Selectors.siteHeader.outerHeight();
      let pageHeight = $(Components.StoreLocatorComponent.Selectors.page).outerHeight();
      let mainHeight = pageHeight - headerHeight;
      $(Components.StoreLocatorComponent.Selectors.main).css({ 'height': mainHeight +"px" });
      let storelocatorHeaderHeight = Components.StoreLocatorComponent.Selectors.storelocatorHeader.outerHeight();

      if (Utils.Responsive.isSM() || Utils.Responsive.isXS()) {
        let asideHeight = Components.StoreLocatorComponent.Selectors.aside.outerHeight();
        let mapActionHeight = Components.StoreLocatorComponent.Selectors.mapAction.outerHeight();
        Components.StoreLocatorComponent.Selectors.mapContainer.css({ 'height': pageHeight - headerHeight - asideHeight -mapActionHeight +"px" });
        Components.StoreLocatorComponent.Selectors.storeListContainer.css({ 'height': pageHeight - headerHeight -mapActionHeight +"px" });
      } else {
        Components.StoreLocatorComponent.Selectors.mapContainer.css({ 'height': "100%" });
        Components.StoreLocatorComponent.Selectors.storeListContainer.css({ 'height': pageHeight - headerHeight - storelocatorHeaderHeight +"px" });
      }
    },

	containsStoreLocatorComponent: () => {
	  return Components.StoreLocatorComponent.Selectors.storeLocatorComponentWrapper.length > 0;
	},

    init: function () {

      if(!Components.StoreLocatorComponent.containsStoreLocatorComponent()) {
	    return;
      }
	  
      Components.StoreLocatorComponent.data = Utils.jsonDA(Components.StoreLocatorComponent.Selectors.mapContainer, 'storelocator');

      logger.i(Components.StoreLocatorComponent.data);

      const mapOptions = {
        /* Key of `storeCode` into JSON */
        "markerkey": "storeCode",
        /* Options will be passed to cluster official library */
        ClusterMaxZoom: 13,
        ClusterMinSize: 2,
        ClusterGridSize: 30,
        /* Options passed to Clusterer */
        ClusterImagePath: Components.StoreLocatorComponent.data.docroot + '/images/common/store-locator/cluster/cluster',
        ClusterImageExt: "png",
        Engines: {
          Google: {
            mapTypeControl: false,
            overviewMapControl: true,
            panControl: true,
            scaleControl: false,
            streetViewControl: false,
            scrollwheel: true,
            minZoom: 1,
            maxZoom: 18,
            zoom: 8,
            zoomControl: false,
            gestureHandling: 'cooperative'
          }
        },

        /* Allowed types of address returned by google autocomplete */
        AllowedAddressType: ["locality", "geocode", "country", "route", "street_address"], // "political"
        /* Max number of entries into LocalStorage */
        maxlastentries: 5,
        /* (debug) Show or hide a rectangle representing the bounding box into map */
        ShowMapRectangle: (window.location.host.indexOf('.local') > -1)
      };

      Components.StoreLocatorComponent.initTemplate();
      Components.StoreLocatorComponent.storeLocator = new StoreLocator(mapOptions);
      Components.StoreLocatorComponent.promiseGmap = new GoogleMap.GoogleMap(Components.StoreLocatorComponent.storeLocator, Components.StoreLocatorComponent.Selectors.map, mapOptions.Engines.Google);
      Components.StoreLocatorComponent.promiseGsearch = new GoogleSearch(Components.StoreLocatorComponent.storeLocator, Components.StoreLocatorComponent.Selectors.search, {
        componentRestrictions: {country: "it"}
      });
      Components.StoreLocatorComponent.initStoreLocator();
      Components.StoreLocatorComponent.bindEvents();

      Components.StoreLocatorComponent.setMainHeight();

      $(window).on('resize', function() {
        Components.StoreLocatorComponent.setMainHeight();
      });
    },

  });

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components,
  window.App.Pages
);
